export default __webpack_public_path__ + "static/media/recipe-example.0a1325cf.png";